
/* CSS for Card of Dashboard Starts*/
export const cardStyles = {
    cursor: 'pointer',
    transition: '0.3s',
    display: 'flex',
    alignItems: 'center',
    padding: 2,
};

export const iconStyles = {
    fontSize: 40,
    color: '#f5f5f5',
    marginRight: 2,
};

/* CSS for Card of Dashboard Ends*/